export enum ClickedModalValues {
  Letsgo = "letsgo",
  Dolater = "dolater",
  Cross = "cross"
}

export enum ExitSetupButtonValues {
  Top = "top",
  Bottom = "bottom"
}

export enum ResetModalClickedValues {
  Ok = "ok",
  Cancel = "cancel",
  Cross = "cross",
  Blur = "blur"
}

export enum ReminderPlatformValues {
  Native = "native",
  Mobile = "mobile"
}
